export default __webpack_public_path__ + "static/media/ASBM.bcf0b2e4.jpg";